import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiDesktop {
    constructor() {

    }

    desktop() {
    }
}
